/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownEthnicity } from '../models/db_DropdownEthnicity';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class Ethnicities {
    /**
     * Get a list of ethnicities
     * @returns db_DropdownEthnicity OK
     * @throws ApiError
     */
    public static listEthnicities(): CancelablePromise<Array<db_DropdownEthnicity>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ethnicities',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
